// Imports
// ------
import React from 'react';
import ReactHtmlParser, { processNodes } from "react-html-parser";

// Styles
// ------
import {
    TitleH2,
    TitleH3,
    TitleH4,
    TitleH5,
    Text,
    BlockQuote,
    Ul,
    Ol,
    Anchor
} from './styles';

// Component
// ------
const Parser = ({ content, textSmall, textLarge, externalLinks }) => {
    const options = {
        decodeEntities: true,
        transform
    };

    function transform(node, index) {
        if (node.type === "tag" && (node.name === "h1" || node.name === "h2")) {
            node.name = "h2";
            return (
                <TitleH2 key={index}>{processNodes(node.children, transform)}</TitleH2>
            )
        }

        if (node.type === "tag" && node.name === "h3") {
            return (
                <TitleH3 key={index}>{processNodes(node.children, transform)}</TitleH3>
            )
        }

        if (node.type === "tag" && node.name === "h4") {
            return (
                <TitleH4 key={index}>{processNodes(node.children, transform)}</TitleH4>
            )
        }

        if (node.type === "tag" && node.name === "h5") {
            return (
                <TitleH5 key={index}>{processNodes(node.children, transform)}</TitleH5>
            )
        }

        if (node.type === "tag" && node.name === "p") {
            return (
                <Text
                    key={index}
                    textLarge={textLarge}
                    textSmall={textSmall}
                >
                    {processNodes(node.children, transform)}
                </Text>
            )
        }

        if (node.type === "tag" && node.name === "blockquote") {
            return (
                <BlockQuote
                    key={index}
                    textLarge={textLarge}
                >
                    {processNodes(node.children, transform)}
                </BlockQuote>
            )
        }

        if (node.type === "tag" && node.name === "a") {
            node.attribs.target = "_blank";
            return (
                <Anchor key={index} className="ch" href={node.attribs.href} rel={externalLinks && `noopener noreferrer`} target={node.attribs.target}>{processNodes(node.children, transform)}</Anchor>
            )
        }

        if (node.type === "tag" && node.name === "ul") {
            return (
                <Ul key={index} textLarge={textLarge}>
                    {processNodes(node.children, index, transform)}
                </Ul>
            )
        }

        if (node.type === "tag" && node.name === "ol") {
            return (
                <Ol key={index} textLarge={textLarge}>
                    {processNodes(node.children, index, transform)}
                </Ol>
            )
        }
    }

    return (
        <>
            {ReactHtmlParser(content, options)}
        </>
    )
}

export default Parser;